module.exports = __webpack_public_path__ + "img/icon2.223523c4.png";